// extracted by mini-css-extract-plugin
module.exports = {"button":"content-seo_button__PwB6o","content":"content-seo_content__0pF8_","ellipses":"content-seo_ellipses__0lqVh"};